import { Repeat } from 'lucide-react'
import { subscriptionOrderLabel, type OrderPlanFields } from './subscriptionLabel'

/** "Subscription · 2 of 4" on an order a subscription made; nothing on any other order. */
export function SubscriptionOrderChip({ order, className = '' }: { order: OrderPlanFields; className?: string }) {
  const label = subscriptionOrderLabel(order)
  if (!label) return null
  return (
    <span
      data-testid="order-subscription"
      title={order.planName ? `Subscription: ${order.planName}` : undefined}
      className={`inline-flex items-center gap-1 whitespace-nowrap text-[10px] font-semibold px-2 py-0.5 rounded bg-indigo-500/10 text-indigo-700 dark:text-indigo-300 border border-indigo-500/20 ${className}`}
    >
      <Repeat size={10} aria-hidden="true" />
      {label}
    </span>
  )
}
